import * as api from '../../api/mra/mra';
import { makeApiActionCreatorV3 } from '../utils';

export const MRA_MODELS_FETCH_START = 'MRA/MRA_MODELS_FETCH_START';
export const MRA_MODELS_FETCH_SUCCESS = 'MRA/MRA_MODELS_FETCH_SUCCESS';
export const MRA_MODELS_FETCH_ERROR = 'MRA/MRA_MODELS_FETCH_ERROR';

export const MRA_MODEL_DELETE_START = 'MRA/MRA_MODEL_DELETE_START';
export const MRA_MODEL_DELETE_SUCCESS = 'MRA/MRA_MODEL_DELETE_SUCCESS';
export const MRA_MODEL_DELETE_ERROR = 'MRA/MRA_MODEL_DELETE_ERROR';

export const MRA_MODEL_CREATE_START = 'MRA/MRA_MODEL_CREATE_START';
export const MRA_MODEL_CREATE_SUCCESS = 'MRA/MRA_MODEL_CREATE_SUCCESS';
export const MRA_MODEL_CREATE_ERROR = 'MRA/MRA_MODEL_CREATE_ERROR';

export const MRA_MODEL_FETCH_START = 'MRA/MRA_MODEL_FETCH_START';
export const MRA_MODEL_FETCH_SUCCESS = 'MRA/MRA_MODEL_FETCH_SUCCESS';
export const MRA_MODEL_FETCH_ERROR = 'MRA/MRA_MODEL_FETCH_ERROR';

export const MRA_ANALYSIS_FETCH_START = 'MRA/MRA_ANALYSIS_FETCH_START';
export const MRA_ANALYSIS_FETCH_SUCCESS = 'MRA/MRA_ANALYSIS_FETCH_SUCCESS';
export const MRA_ANALYSIS_FETCH_ERROR = 'MRA/MRA_ANALYSIS_FETCH_ERROR';

export const MRA_ANALYSIS_NOI_FETCH_START = 'MRA/MRA_ANALYSIS_NOI_FETCH_START';
export const MRA_ANALYSIS_NOI_FETCH_SUCCESS =
  'MRA/MRA_ANALYSIS_NOI_FETCH_SUCCESS';
export const MRA_ANALYSIS_NOI_FETCH_ERROR = 'MRA/MRA_ANALYSIS_NOI_FETCH_ERROR';

export const MRA_MODEL_CALCULATE_START = 'MRA/MRA_MODEL_CALCULATE_START';
export const MRA_MODEL_CALCULATE_SUCCESS = 'MRA/MRA_MODEL_CALCULATE_SUCCESS';
export const MRA_MODEL_CALCULATE_ERROR = 'MRA/MRA_MODEL_CALCULATE_ERROR';

export const MRA_MODEL_SETTING_PERSIST_START =
  'MRA/MRA_MODEL_SETTING_PERSIST_START';
export const MRA_MODEL_SETTING_PERSIST_SUCCESS =
  'MRA/MRA_MODEL_SETTING_PERSIST_SUCCESS';
export const MRA_MODEL_SETTING_PERSIST_ERROR =
  'MRA/MRA_MODEL_SETTING_PERSIST_ERROR';

export const MRA_MODEL_SELECT = 'MRA/MRA_MODEL_SELECT';

export const fetchMraModels = makeApiActionCreatorV3(
  api.fetchMraModels,
  MRA_MODELS_FETCH_START,
  MRA_MODELS_FETCH_SUCCESS,
  MRA_MODELS_FETCH_ERROR,
);
export const deleteMraModel = makeApiActionCreatorV3(
  api.deleteMraModel,
  MRA_MODEL_DELETE_START,
  MRA_MODEL_DELETE_SUCCESS,
  MRA_MODEL_DELETE_ERROR,
);
export const createMraModel = makeApiActionCreatorV3(
  api.createMraModel,
  MRA_MODEL_CREATE_START,
  MRA_MODEL_CREATE_SUCCESS,
  MRA_MODEL_CREATE_ERROR,
);
export const fetchMraModel = makeApiActionCreatorV3(
  api.fetchMraModel,
  MRA_MODEL_FETCH_START,
  MRA_MODEL_FETCH_SUCCESS,
  MRA_MODEL_FETCH_ERROR,
);
export const fetchMraAnalysis = makeApiActionCreatorV3(
  api.fetchMraAnalysisModel,
  MRA_ANALYSIS_FETCH_START,
  MRA_ANALYSIS_FETCH_SUCCESS,
  MRA_ANALYSIS_FETCH_ERROR,
);
export const fetchMraAnalysisNoi = makeApiActionCreatorV3(
  api.fetchMraAnalysisNoi,
  MRA_ANALYSIS_NOI_FETCH_START,
  MRA_ANALYSIS_NOI_FETCH_SUCCESS,
  MRA_ANALYSIS_NOI_FETCH_ERROR,
);
export const calculateMraModel = makeApiActionCreatorV3(
  api.calculateMraModel,
  MRA_MODEL_CALCULATE_START,
  MRA_MODEL_CALCULATE_SUCCESS,
  MRA_MODEL_CALCULATE_ERROR,
);
export const persistMraModelSetting = makeApiActionCreatorV3(
  api.persistMraModelSetting,
  MRA_MODEL_SETTING_PERSIST_START,
  MRA_MODEL_SETTING_PERSIST_SUCCESS,
  MRA_MODEL_SETTING_PERSIST_ERROR,
);

export function selectModel(modelId) {
  return async dispatch => {
    dispatch({ type: MRA_MODEL_SELECT, data: modelId });
  };
}
